import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	DeleteBeneficiaryAddressV4,
	DeleteBeneficiaryAddressV4Params,
	DeleteBeneficiaryAddressV4Response,
} from 'domain/usecases';

export class RemoteDeleteBeneficiaryAddressV4 implements DeleteBeneficiaryAddressV4 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteBeneficiaryAddressV4Response>,
	) {}

	async delete(
		params: DeleteBeneficiaryAddressV4Params,
	): Promise<DeleteBeneficiaryAddressV4Response> {
		const {signal} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
